import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$shortId/")({
  beforeLoad: async ({ params }) => {
    // Redirect to the revision route with revision 1 as default
    throw redirect({
      to: "/$shortId/$revision",
      params: {
        shortId: params.shortId,
        revision: "1",
      },
    });
  },
});
